import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./css/App.css";
import "./backend/firebaseConfig"; // Ensure firebaseConfig.js is imported to initialize the app
import { UserEmailProvider } from "./frontend/SignIn/UserEmailContext";
import { UserPermissionsProvider } from "./frontend/SignIn/UserPermissionsContext";
import { AdviserProvider } from "./context/Adviser/AdviserContext";
import { HelmetProvider } from "react-helmet-async";
import { AdviserListWithUnappointedProvider } from "./context/Adviser/Utils/UnappointedAppointedAdviserEmailList";
import { AdviserListProvider } from "./context/Adviser/Utils/AdviserEmailList";
import { installFrameResizeObserver } from "./utils/installFrameResizeObserver";

installFrameResizeObserver();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <UserEmailProvider>
      <AdviserListProvider>
        <AdviserListWithUnappointedProvider>
          <AdviserProvider>
            <UserPermissionsProvider>
              <App />
            </UserPermissionsProvider>
          </AdviserProvider>
        </AdviserListWithUnappointedProvider>
      </AdviserListProvider>
    </UserEmailProvider>
  </HelmetProvider>,
  // </React.StrictMode>
);

// For performance measurement
reportWebVitals();
